import styled from 'styled-components';

import { GroupOperatorType } from 'src/common/enums/categorization-dashboard';

export const StyledContainer = styled.div`
  display: flex;
  padding-left: 3rem;
  width: 100%;
`;

export const StyledCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  height: fit-content;
`;

export const StyledRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

export const StyledLeftContent = styled.div<{ operator: GroupOperatorType }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-top: 0.1rem solid
    ${({ theme, operator }) =>
      operator === GroupOperatorType.AND
        ? theme.colors.statusTag.purple.background
        : theme.colors.statusTag.blue.background};
  border-top-left-radius: 0.6rem;
  border-left: 0.1rem solid
    ${({ theme, operator }) =>
      operator === GroupOperatorType.AND
        ? theme.colors.statusTag.purple.background
        : theme.colors.statusTag.blue.background};
  border-bottom: 0.1rem solid
    ${({ theme, operator }) =>
      operator === GroupOperatorType.AND
        ? theme.colors.statusTag.purple.background
        : theme.colors.statusTag.blue.background};
  border-bottom-left-radius: 0.6rem;
  margin: 2.5rem 0;
  padding-right: 3rem;

  > div {
    margin-left: -3rem;

    > div > button {
      background-color: ${({ theme, operator }) =>
        operator === GroupOperatorType.AND
          ? theme.colors.statusTag.purple.background
          : theme.colors.statusTag.blue.background};
      border-radius: 1.2rem;
      width: 5.9rem;
      height: 2.2rem;
      text-transform: capitalize;
      font-family: ${({ theme }) => theme.fonts.familyUbuntu};
      font-size: ${({ theme }) => theme.fonts.sizes.tiny};
      font-weight: ${({ theme }) => theme.fonts.weight.regular};
      text-align: center;
      padding: 4px 8px 4px 12px;
    }
  }
`;

export const StyledRightContent = styled.div<{ operator: GroupOperatorType }>`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  padding: 0.8rem;
  width: 100%;
  border: 0.1rem solid
    ${({ theme, operator }) =>
      operator === GroupOperatorType.AND
        ? theme.colors.statusTag.purple.background
        : theme.colors.statusTag.blue.background};
  border-radius: 0.6rem;
  background-color: ${({ theme }) => theme.colors.grey['100']};
`;
